import MatterLitigationDateTypes from "@/components/features/settings/defaults/MatterLitigationDateTypes";
import { MatterLitigationDatePlansTable } from "@/components/features/settings/defaults/matter-litigation-date-plans/MatterLitigationDatePlansTable";
import { Button, GlobalNotAuthorized, Text } from "@/components/ui";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/shadcn/Tabs/Tabs";
import { useUser } from "@/components/UserProvider";
import { cn } from "@/lib/utils/cn";
import {
  PAGE_PERMISSION_KEYS,
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";

export const Route = createFileRoute(
  "/_auth/matters/settings/litigation-plans",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission, hasActionPermission } = useUser();

  const canView = hasPagePermission(
    PAGE_PERMISSION_KEYS.mattersSettingsLitigationPlans,
  );
  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.matterLitigationDatePlan,
    ACTION_PERMISSION_VALUES.create,
  );

  const [activeTab, setActiveTab] = useState("litigation-date-types");
  const [isAddingDateType, setIsAddingDateType] = useState(false);
  const [isAddingPlan, setIsAddingPlan] = useState(false);

  if (!canView) {
    return <GlobalNotAuthorized />;
  }

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <Text as="h1" variant="title" className="mb-6 shrink-0">
        Litigation plans
      </Text>
      <div className="mb-2 flex w-full items-end justify-between gap-4 border-b">
        <TabsList className="h-auto flex-1 justify-start gap-8 rounded-none border-0 bg-transparent p-0">
          <TabsTrigger
            value="litigation-date-types"
            className="rounded-none px-0 pb-4 text-base data-[state=active]:bg-transparent"
          >
            <Text
              as="span"
              variant={
                activeTab === "litigation-date-types" ? "body" : "subHeading"
              }
              className={cn(
                activeTab === "litigation-date-types" &&
                  "text-foreground font-semibold",
              )}
            >
              Litigation date types
            </Text>
          </TabsTrigger>
          <TabsTrigger
            value="litigation-plans"
            className="rounded-none px-0 pb-4 text-base data-[state=active]:bg-transparent"
          >
            <Text
              as="span"
              variant={activeTab === "litigation-plans" ? "body" : "subHeading"}
              className={cn(
                activeTab === "litigation-plans" &&
                  "text-foreground font-semibold",
              )}
            >
              Litigation plans
            </Text>
          </TabsTrigger>
        </TabsList>
        <div className="flex shrink-0 flex-wrap items-center gap-2 pb-4">
          {activeTab === "litigation-date-types" && canCreate ? (
            <Button
              variant="foreground"
              size="md"
              onClick={() => {
                setIsAddingDateType(true);
              }}
            >
              <Plus className="h-4 w-4" aria-hidden="true" />
              Add type
            </Button>
          ) : null}
          {activeTab === "litigation-plans" && canCreate ? (
            <Button
              variant="foreground"
              size="md"
              onClick={() => {
                setIsAddingPlan(true);
              }}
            >
              <Plus className="h-4 w-4" />
              Add plan
            </Button>
          ) : null}
        </div>
      </div>
      <TabsContent value="litigation-date-types" className="mt-0">
        <MatterLitigationDateTypes
          isAdding={isAddingDateType}
          setIsAdding={setIsAddingDateType}
        />
      </TabsContent>
      <TabsContent value="litigation-plans" className="mt-0">
        <MatterLitigationDatePlansTable
          isAddingPlan={isAddingPlan}
          setIsAddingPlan={setIsAddingPlan}
        />
      </TabsContent>
    </Tabs>
  );
}
